import { useLocation } from 'react-router-dom';
import {
  ButtonPrimary,
  ButtonSecondary,
  PermissionDenied,
  PermissionEnum,
  Popup,
  SidePanel,
  SidePanelType,
} from '@ui/src';
import { useAppSelector } from '@store';
import useLinkedClientsForm from './hooks/use-linked-clients-form';
import LinkedClientForm from '../../../components/external-accounts/linked-client-form';

const CreateLinkedClientForm = () => {
  const { linkedClientsTakeCount, pspIntegrations, pspPartners } =
    useAppSelector((state) => state.externalAccounts);
  const { activePermissions } = useAppSelector((state) => state.root);

  const { search } = useLocation();

  const {
    panelIsOpen,
    isDirty,
    setDirtyPopupVisible,
    handleClose,
    globalError,
    requestInProgress,
    onSubmit,
    dirtyPopupVisible,
    control,
    availablePspPartners,
    pspPartnerId,
    errors,
    autocompleteList,
    isLoading,
    onSearch,
    setSelectedOrganization,
    onClear,
    setExternalOrganizationsListVisible,
    externalOrganizationSearch,
    setExternalOrganizationSearch,
    getPspIntegrationOrganizationsAction,
    pspIntegrationOrganizationsList,
    externalOrganizationsListVisible,
    organizationsIsLoading,
    organizationsIsFetching,
  } = useLinkedClientsForm({
    search,
    linkedClientsTakeCount,
    pspIntegrations,
    pspPartners,
  });

  let content;

  if (
    !activePermissions?.includes(
      PermissionEnum.EXTERNAL_ORGANIZATIONS_CREATE_ACTION,
    )
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <SidePanel
          title="Link Client"
          isOpen={panelIsOpen}
          type={SidePanelType.AML}
          sidepanelExpandedKey="psp-partner-link-client"
          onClose={() => {
            if (isDirty) {
              setDirtyPopupVisible(true);
            } else {
              handleClose();
            }
          }}
          errorSidepanel={globalError}
          footer={
            <>
              <ButtonPrimary
                text={requestInProgress ? 'Loading...' : 'Link'}
                disabled={requestInProgress}
                onClick={onSubmit}
                bold
              />
              <ButtonSecondary
                text="Close"
                className="button-white"
                onClick={() => {
                  if (isDirty) {
                    setDirtyPopupVisible(true);
                  } else {
                    handleClose();
                  }
                }}
              />
            </>
          }
          closeOnClickOutside
        >
          <LinkedClientForm
            control={control}
            pspPartners={availablePspPartners}
            pspPartnerId={pspPartnerId}
            errors={errors}
            autocompleteList={autocompleteList}
            isLoading={isLoading}
            onSearch={onSearch}
            setSelectedOrganization={setSelectedOrganization}
            onClear={onClear}
            setExternalOrganizationsListVisible={
              setExternalOrganizationsListVisible
            }
            externalOrganizationSearch={externalOrganizationSearch}
            setExternalOrganizationSearch={setExternalOrganizationSearch}
            getPspIntegrationOrganizationsAction={
              getPspIntegrationOrganizationsAction
            }
            pspIntegrationOrganizationsList={pspIntegrationOrganizationsList}
            externalOrganizationsListVisible={externalOrganizationsListVisible}
            organizationsIsLoading={organizationsIsLoading}
            organizationsIsFetching={organizationsIsFetching}
          />
        </SidePanel>
        <Popup
          title="You have unsaved changes"
          description=""
          onCancelClick={() => setDirtyPopupVisible(false)}
          onOkClick={handleClose}
          cancelButtonText="Cancel"
          okButtonText="Close"
          isVisible={dirtyPopupVisible}
          parent={document.getElementById('dirty-popup') as HTMLElement}
        />
        <div id="dirty-popup" />
      </>
    );
  }

  return content;
};

export default CreateLinkedClientForm;
